import React, { useEffect, useState, createContext, useContext, useReducer } from 'react';
// import { faker } from '@faker-js/faker';
import { eventsReducer } from './Reducers';
import { AppContextType } from '../models/context/appContext-type';
// import { PaypalPaymentDTO } from '../models';
import { useAccountContext } from './AccountContext';
import { useNotificationContext } from './NotificationContext';



type ContextProps = {
    children:React.ReactNode;
}

const AppContext = createContext<AppContextType | null>(null);

// faker.seed(99)


const Context = ({ children }: ContextProps) => {
    // .......................ACCOUNT
    // const {signedIn, setSignedIn, token, setToken, refreshToken, setRefreshToken, frontSessionId, setFrontSessionId, deviceId, setDeviceId, profile, setProfile}= useAccountContext()
    const {
        userId, 
        setUserId,
        username, 
        setUsername,
        accountType, 
        setAccountType,
        signedIn, 
        setSignedIn, 
        requiredDocuments, 
        setRequiredDocuments, 
        frontSessionId, 
        setFrontSessionId, 
        deviceId, 
        setDeviceId, 
        profile, 
        setProfile, 
        phoneValidation, 
        setPhoneValidation,
        isRecoveringPassword, 
        setIsRecoveringPassword
    }= useAccountContext()

    
    // ......................PAYMENT
    // const [paymentState, setPaymentState] = useState<PaypalPaymentDTO>();

    // ...................... NOTIFICATION
    const { notificationCount, setNotificationCount } = useNotificationContext()


    // ......................RENDER
    return (
        <AppContext.Provider value={{ 
            accountCTX: {
                userId, 
                setUserId,
                username, 
                setUsername,
                accountType, 
                setAccountType,
                signedIn, 
                setSignedIn, 
                requiredDocuments, 
                setRequiredDocuments, 
                frontSessionId, 
                setFrontSessionId, 
                deviceId, 
                setDeviceId, 
                profile, 
                setProfile, 
                phoneValidation, 
                setPhoneValidation,
                isRecoveringPassword, 
                setIsRecoveringPassword
            },
            // paypalPaymentCTX: {paymentState, setPaymentState},
            notificationCTX: { notificationCount, setNotificationCount },  
        }}>
            {children}
        </AppContext.Provider>
    )
}

export default Context


export const useContextState =() => {
    const context = useContext(AppContext);
    if (!context){
        throw new Error(
            "useContextState must be used within Context"
        )
    }

    // console.log(context)
    return context
}